import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const COMMENTS_LIST_SHADOW_WIDTH = '2px';

export const Footer = styled.div`
  background-color: inherit;
  bottom: 0;
  margin: 0;
  margin-left: -${COMMENTS_LIST_SHADOW_WIDTH};
  margin-right: -${COMMENTS_LIST_SHADOW_WIDTH};
  padding-bottom: ${tokens.spacer.x3};
  padding-left: ${COMMENTS_LIST_SHADOW_WIDTH};
  padding-right: ${COMMENTS_LIST_SHADOW_WIDTH};
  position: sticky;
`;
